import { render, staticRenderFns } from "./StatsOverdueDistributionsModal.vue?vue&type=template&id=32f1937a&"
import script from "./StatsOverdueDistributionsModal.vue?vue&type=script&lang=js&"
export * from "./StatsOverdueDistributionsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports